<div class="app-shell">

  <!-- Top Toolbar -->
  <p-toolbar styleClass="app-toolbar">
    <ng-template #start>
      <div class="toolbar-brand">
        <img src="quimus-logo.svg" height="32" alt="Quimus" class="logo" />
        <span class="toolbar-title">Toolbox</span>
      </div>
    </ng-template>
    <ng-template #end>
      <div class="toolbar-user">
        <span class="username">{{ username() }}</span>
        <p-button
          icon="pi pi-sign-out"
          label="Logout"
          severity="secondary"
          size="small"
          (onClick)="logout()"
        />
      </div>
    </ng-template>
  </p-toolbar>

  <!-- Body: Sidebar + Content -->
  <div class="app-body">

    <nav class="sidebar">
      <a class="nav-item nav-item--top" routerLink="/" routerLinkActive="nav-item--active"
         [routerLinkActiveOptions]="{ exact: true }">
        <i class="pi pi-home nav-item-icon"></i>
        <span>Start</span>
      </a>

      @for (section of sections; track section.label) {
        <div class="nav-section">

          <!-- Abschnitts-Header (klickbar zum Auf-/Zuklappen) -->
          <button class="nav-header" (click)="toggle(section)">
            <i [class]="section.icon" class="nav-header-icon"></i>
            <span class="nav-header-label">{{ section.label }}</span>
            <i class="pi nav-chevron"
               [class.pi-chevron-down]="section.expanded()"
               [class.pi-chevron-right]="!section.expanded()">
            </i>
          </button>

          <!-- Sub-Items -->
          @if (section.expanded()) {
            <ul class="nav-items">
              @for (item of section.items; track item.label) {
                <li>
                  @if (item.routerLink && !item.disabled) {
                    <a class="nav-item"
                       [routerLink]="item.routerLink"
                       routerLinkActive="nav-item--active">
                      <i [class]="item.icon" class="nav-item-icon"></i>
                      <span>{{ item.label }}</span>
                    </a>
                  } @else {
                    <span class="nav-item nav-item--disabled">
                      <i [class]="item.icon" class="nav-item-icon"></i>
                      <span>{{ item.label }}</span>
                    </span>
                  }
                </li>
              }
            </ul>
          }

        </div>
      }
    </nav>

    <main class="content">
      <router-outlet />
    </main>

  </div>
</div>
